module.exports = __webpack_public_path__ + "img/TITLE-02.08633c09.png";